import React from 'react'
import { ContentHeader } from '../../layout/Content'
import UtilitiesHeaderStyle from './css/UtilitiesHeaderStyle'

function UtilitiesHeader() {
  return (
    <ContentHeader title='Utilities'>
      <UtilitiesHeaderStyle />
    </ContentHeader>
  )
}

export default React.memo(UtilitiesHeader)
